import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuOutlined, CloseOutlined, CodeOutlined } from '@ant-design/icons';
import './Navbar.scss';
import logo from './../assets/logo.svg';
import replicatOneImg from './../assets/replicat-one.jpg';
import tessierImg from './../assets/tessier.png';
import michaelImg from './../assets/michael.jpg';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Replicats Logo" className="logo-image" />
        </Link>
      </div>

      <div className="navbar-mobile-controls">
        <Link to="https://app.replicats.ai/sign-in" className="mobile-terminal-btn" title="Open Terminal">
          <CodeOutlined />
        </Link>
        <button className="hamburger-btn" onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
        </button>
      </div>

      <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/about" className="nav-link" onClick={closeMenu}>ABOUT US</Link>
        <div className="nav-dropdown">
          <span className="nav-link dropdown-toggle">AGENTS</span>
          <div className="dropdown-menu">
            <Link to="/agent/replicat-one" className="dropdown-item" onClick={closeMenu}>
              <img src={replicatOneImg} alt="Replicat-One" className="agent-thumbnail" />
              Replicat-One
            </Link>
            <Link to="/agent/tessier" className="dropdown-item" onClick={closeMenu}>
              <img src={tessierImg} alt="Tessier" className="agent-thumbnail" />
              Tessier
            </Link>
            <Link to="/agent/michael" className="dropdown-item" onClick={closeMenu}>
              <img src={michaelImg} alt="Michael" className="agent-thumbnail" />
              Michael
            </Link>
          </div>
        </div>
        <Link to="/token" className="nav-link" onClick={closeMenu}>$RCAT</Link>
        <Link to="https://app.replicats.ai/sign-in" className="nav-link button desktop-terminal-btn" onClick={closeMenu}>OPEN TERMINAL</Link>
      </div>
    </nav>
  );
};

export default Navbar;